module.exports = {
  pathPrefix: '/', // Prefix for all links. If you deploy your site to example.com/portfolio your pathPrefix should be "portfolio"
  title: 'Cookle 料理サイトの人気レシピを簡単検索！', // Navigation and Site Title
  titleAlt: 'Cookle 料理サイトの人気レシピを簡単検索！', // Title for JSONLD
  description: '余った食材🥕🥩🥬を組み合わせて作れる料理を簡単検索! クックパッド、白ごはん.com、ナディアなどで人気のレシピをランキング順で表示! 人気順検索ならくっくる。',
  url: 'https://cookle.asymmetry.life', // Domain of your site. No trailing slash!
  siteUrl: 'https://cookle.asymmetry.life', // url + pathPrefix
  siteLanguage: 'ja', // Language Tag on <html> element
  logo: 'static/logo/icon-512x512.png', // Used for SEO
  banner: 'static/logo/icon-512x512.png',
  favicon: 'static/icons/icon-48x48.png',
  // JSONLD / Manifest
  shortName: 'Cookle', // shortname for manifest. MUST be shorter than 12 characters
  author: '松下', // Author for schemaORGJSONLD
  themeColor: '#ff9844',
  backgroundColor: 'white',
  twitter: '@CookleMe', // Twitter Username
  canonical: 'https://cookle.asymmetry.life', // Corrected spelling
};